var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Popup",
    _vm._b(
      {
        attrs: {
          active: _vm.isErrorPopupOpen,
          animation: "fade",
          transparentBg: false,
          fullsize: false,
          hasBg: false,
          borderRadiusBySide: ["16px", "16px", "16px", "16px"],
        },
        on: { close: _vm.close },
      },
      "Popup",
      { modalContainerStyles: _vm.modalContainerStyles },
      false
    ),
    [_c("ErrorAlert", { on: { hidePopup: _vm.close } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }